export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["反钓鱼设置是使用账户时的额外保护机制。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您设置的欢迎短语将显示在账户的每一页顶部。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正确的短语将表明您在正确的网站上，不正确的短语将是一个信号：不要进行操作，立即联系我们的系统安全部门。"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["启用反钓鱼"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["反钓鱼短语"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["反钓鱼"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更改将在下次授权后生效"])},
  "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您选择的短语会显示在网上银行页面顶部，确认您正在访问真实网站。"])}
}